// Message Center Utility Functions
// Character limits and messaging utilities

// SMS Character Limits
export const SMS_CHAR_LIMIT = 160; // Standard SMS character limit
export const SMS_CHAR_LIMIT_WITH_EMOJI = 70; // SMS limit when emojis are present (UCS-2 encoding)

// Push Notification Character Limits
export const PUSH_CHAR_LIMIT = 178; // iOS push notification character limit

// Message Channel Types
export const MESSAGE_CHANNELS = {
  SMS: 'sms',
  PUSH: 'push',
};

// SMS Pricing
export const SMS_COST_PER_SEGMENT = 0.02; // Cost per SMS segment in USD

/**
 * Detects if text contains emoji characters
 * @param {string} text - The text to check for emojis
 * @returns {boolean} - True if emojis are present, false otherwise
 */
export const containsEmoji = (text) => {
  const emojiRegex =
    /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}]/gu;
  return emojiRegex.test(text);
};

/**
 * Gets the character limit for a message based on channel type and content
 * @param {string} channelType - The message channel type ('sms' or 'push')
 * @param {string} messageText - The message text to analyze
 * @returns {number} - The character limit for the given channel and content
 */
export const getCharacterLimit = (channelType, messageText) => {
  if (channelType === MESSAGE_CHANNELS.PUSH) {
    return PUSH_CHAR_LIMIT;
  }

  if (channelType === MESSAGE_CHANNELS.SMS) {
    // For SMS, check if emojis are present to determine limit
    return containsEmoji(messageText)
      ? SMS_CHAR_LIMIT_WITH_EMOJI
      : SMS_CHAR_LIMIT;
  }

  // Default fallback (should not happen with proper channel types)
  return SMS_CHAR_LIMIT;
};
